export default __webpack_public_path__ + "static/media/whylogo5.2c94d84e.png";